<template>
  <div>
    <LayerModelGeneral
      v-if="generalSrcUrl"
      sourceId="source-model-general"
      layerId="layer-model-general"
      :sourceUrl="generalSrcUrl"
      :altitude="generalAltitude"
      :origin="generalOrigin"
      @loadingModelDone="modelLoaded"
    />
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from 'vuex'
import { getFileBlobv2 } from '@/services/files.service'
import { LayerModelGeneral } from '@/components/map/layers/modelview-layers'
import { PLANVIEW_PREFIX } from '@/store/module-prefixes'
import { IS_LOADING_MODEL } from '@/store/mutation-types'

let fileAborter = null

export default {
  name: 'LayerModel',
  components: {
    LayerModelGeneral
  },
  data() {
    return {
      generalAltitude: null,
      generalOrigin: null,
      generalSrcUrl: null
    }
  },
  computed: {
    ...mapGetters({
      selectedLevelId: 'selectedLevelId'
    }),
    ...mapState({
      selectedLevel: (state) => state.selectedLevel
    }),
    ...mapState(PLANVIEW_PREFIX, {
      currentModel: (state) => state.currentModel
    })
  },
  watch: {
    currentModel: {
      immediate: true,
      handler() {
        this.clearModels()
        this.getModel()
      }
    },
    selectedLevelId() {
      this.clearModels()
      this.getModel()
    }
  },
  beforeUnmount() {
    this.setIsModelLoading({ value: false })
  },
  methods: {
    ...mapMutations(PLANVIEW_PREFIX, {
      setIsModelLoading: IS_LOADING_MODEL
    }),
    modelLoaded() {
      return this.setIsModelLoading({ value: false })
    },
    async getModel() {
      if (fileAborter) fileAborter.abort()
      fileAborter = new AbortController()
      this.setIsModelLoading({ value: true })
      const model =
        this.selectedLevel?.models3d[
          this.currentModel.substring(this.currentModel.lastIndexOf('_') + 1)
        ]
      if (!model) {
        this.setIsModelLoading({ value: false })
        return
      }
      try {
        const endpoint = `/documents/${model.storageFileName}`
        const res = await getFileBlobv2(endpoint, fileAborter.signal)
        if (!res) return
        const url = window.URL.createObjectURL(res.data)
        this.setIsModelLoading({ value: false })
        this.generalAltitude = model.coordinate.coordinates[2] * -1
        this.generalOrigin = [model.coordinate.coordinates[0], model.coordinate.coordinates[1]]
        this.generalSrcUrl = url
      } catch (e) {
        if (e.status === 'canceled') this.setIsModelLoading({ value: false })
        console.error(e)
      }
    },
    clearModels() {
      this.generalSrcUrl = null
    }
  }
}
</script>
